module.exports = __webpack_public_path__ + "img/vertical_2_1_7005.ed470e1d.png";